import { Container, Card } from "react-bootstrap";
import { Row, Col, Tag, InputNumber, Form, Input, DatePicker, Select, message } from "antd";

import Button from "antd-button-color";

import { formatNumber } from "lib/utility";
import { productLists } from "data/product";
import "./style.css";

const i = 11;

const BuyNowContainer = () => {
  return (
    <>
      <Container className="my-5">
        <h4 className="fs-20 mb-4 pt-3">Sewa Sekarang</h4>
        <Row gutter={[16, 16]}>
          <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
            <p className="fw-500 fs-16 mb-0">Barang yang disewa</p>
            <div className="cart-item">
              <Row gutter={[0, 16]}>
                <Col
                  span={24}
                  className="d-flex cart-item-body border-bottom-0"
                  key={productLists[i].name}
                >
                  <Row gutter={[0, 0]} className="w-100">
                    <Col xxl={3} xl={3} lg={4} md={5} sm={5} xs={5}>
                      <img
                        src={`/assets/img/products/${productLists[i].image}`}
                        className="cart-item-img"
                        alt={productLists[i].name}
                      />
                    </Col>
                    <Col xxl={21} xl={21} lg={20} md={19} sm={19} xs={19}>
                      <h5 className="mt-0 fs-12-s fs-16 truncate-2">{productLists[i].name}</h5>
                      {productLists[i].discount > 0 ? (
                        <>
                          <div className="product-card-body-price">
                            <small className="text-muted fw-normal text-decoration-line-through m-b-4 me-2">
                              <Tag className="me-0 mb-0 me-1 label-tag-discount">
                                {productLists[i].discount}%
                              </Tag>
                              Rp {formatNumber(productLists[i].price)}{" "}
                            </small>
                            Rp{" "}
                            {formatNumber(
                              productLists[i].price -
                                productLists[1].price * (productLists[i].discount / 100)
                            )}
                            <small className="fw-normal text-muted">/hari</small>
                          </div>
                        </>
                      ) : (
                        <div className="product-card-body-price">
                          Rp {formatNumber(productLists[i].price)}
                          <small className="fw-normal text-muted">/hari</small>
                        </div>
                      )}
                      <Row gutter={[16, 16]} className="mt-2">
                        <Col xxl={8} xl={8} lg={7} md={12} sm={12} xs={24}>
                          <Input placeholder="Tambah catatan" />
                        </Col>
                        <Col xxl={8} xl={8} lg={7} md={12} sm={12} xs={24}>
                          <DatePicker.RangePicker format="DD/MM/YYYY" className="w-100" />
                        </Col>
                        <Col xxl={8} xl={8} lg={8} md={21} sm={21} xs={21}>
                          <Button
                            ghost
                            type="dark"
                            shape="circle"
                            icon={<i className="far fa-minus fs-11 va-2px" />}
                          />
                          <InputNumber
                            style={{ width: "calc(100% - 37px*2)" }}
                            className="m-l-5 m-r-5 va-middle"
                            defaultValue={1}
                            max={230}
                            min={1}
                          />
                          <Button
                            ghost
                            type="dark"
                            shape="circle"
                            icon={<i className="far fa-plus fs-11 va-2px" />}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <div className="border-bottom-5px mb-4 mt-3" />

                  <p className="fw-500 fs-16 mb-0">Data Pengiriman</p>
                  <hr className="my-2" />
                  <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                      <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Form.Item label="Label Alamat" className="mb-0">
                          <Input placeholder="Rumah, Kantor, Apartemen" />
                        </Form.Item>
                      </Col>
                      <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Form.Item label="Nama Penerima" className="mb-0">
                          <Input placeholder="Nama Penerima" />
                        </Form.Item>
                      </Col>
                      <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Form.Item label="Nomor Telepon" className="mb-0">
                          <Input placeholder="Nomor Telepon" prefix="+62" />
                        </Form.Item>
                      </Col>
                      <Col xxl={12} xl={12} lg={12} md={24} sm={24} xs={24}>
                        <Form.Item label="Kurir Pengiriman" className="mb-0">
                          <Select value="1" placeholder="Kurir Pengiriman">
                            <Select.Option value="1">Karya Nadhi Logistics</Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Kabupaten" className="mb-0">
                          <Input placeholder="Kabupaten" />
                        </Form.Item>
                      </Col>
                      {/* <Col xxl={18} xl={18} lg={18} md={18} sm={18} xs={18}> */}
                      <Col span={18}>
                        <Form.Item label="Kota atau Kecamatan" className="mb-0">
                          <Input placeholder="Tulis Nama Alamat / Kota / Kecamatan tujuan pengiriman" />
                        </Form.Item>
                      </Col>
                      <Col span={6}>
                        <Form.Item label="Kode Pos" className="mb-0">
                          <Input placeholder="Kode Pos" />
                        </Form.Item>
                      </Col>
                      <Col span={24}>
                        <Form.Item label="Alamat Penerima" className="mb-0">
                          <Input.TextArea placeholder="Alamat Penerima" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
            <Card className="checkout-summary">
              <Card.Body>
                <p className="fw-bold fs-14">Ringkasan sewaan</p>
                <p className="fw-light checkout-summary-price fs-14 mb-1">
                  Total Harga (2 barang)
                  <span className="float-end cart-item-price fw-bold">Rp. 120.000</span>
                </p>
                <p className="fw-light checkout-summary-price fs-14 mb-1">
                  Total Ongkos Kirim
                  <span className="float-end cart-item-price fw-bold">Rp. 300.000</span>
                </p>
                <hr />
                <p className="fw-bold checkout-summary-price fs-16">
                  Total Tagihan
                  <span className="float-end fw-bold">Rp. 420.000</span>
                </p>
                <Button
                  block
                  type="dark"
                  size="large"
                  onClick={() => message.success("Pop Up midtrans")}
                >
                  Pilih Pembayaran
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default BuyNowContainer;
